import {
  TOGGLE_MODAL_ORDER,
  SET_ATTACHED_GOODS,
  SET_LAST_GOOD
} from '../actionTypes';

const initialState = {
  showModalOrder: false,
  attachedGoods: { '2': { '7': 1, '8': 1 } }, // для ECG Dongle Full доп. товары
  lastGood: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_MODAL_ORDER:
      return { ...state, showModalOrder: payload };
    case SET_ATTACHED_GOODS:
      return {
        ...state,
        attachedGoods: { ...state.attachedGoods, ...payload }
      };
    case SET_LAST_GOOD:
      return { ...state, lastGood: payload };
    default:
      return state;
  }
};
